const LEGACY_CUG_RATE_RULE_PREFIXES = ['le_standard', 'le_mobile']
const RATE_RULE_FIELD_SEPARATOR = '~'
const RATE_RULE_MIN_FIELD_COUNT = 9
const RATE_RULE_RATE_TYPE_INDEX = 4
const RATE_RULE_PRICE_DELIVERY_INDEX = 5
const CUG_RATE_TYPE = 'C'
const LIVE_PRICE_DELIVERY = 'L'

// Keep this isolated so the legacy URL/cookie fallback can be removed cleanly
// after old GHA rule IDs have aged out.
function isLegacyCugRateRule(ruleId: string): boolean {
  const normalizedRuleId = ruleId.toLowerCase()
  return LEGACY_CUG_RATE_RULE_PREFIXES.some(prefix => normalizedRuleId.startsWith(prefix))
}

// Compact GHA rule IDs keep field order stable and may append fields over time.
// rate_type is the fifth field: C = CUG, B = B2C.
function isCompactCugRateRule(ruleId: string): boolean {
  const fields = ruleId.split(RATE_RULE_FIELD_SEPARATOR)
  if (fields.length < RATE_RULE_MIN_FIELD_COUNT) return false

  return fields[RATE_RULE_RATE_TYPE_INDEX]?.toUpperCase() === CUG_RATE_TYPE
}

export function isEligibleMetasearchCugRateRule(ruleId: string | undefined): boolean {
  if (!ruleId) return false

  if (isCompactCugRateRule(ruleId)) return true

  return isLegacyCugRateRule(ruleId)
}

// price_delivery_method is the sixth compact field: L = live, P = pull.
export function isLiveMetasearchRateRule(ruleId: string | undefined): boolean {
  if (!ruleId) return false

  const fields = ruleId.split(RATE_RULE_FIELD_SEPARATOR)
  if (fields.length < RATE_RULE_MIN_FIELD_COUNT) return false

  return fields[RATE_RULE_PRICE_DELIVERY_INDEX]?.toUpperCase() === LIVE_PRICE_DELIVERY
}
